import styled from 'styled-components/macro'
import { COLORS, LinkButton } from '../GlobalStyles'

export const Education = () => (
  <Wrapper>
    <div className='section-inner education'>
      <h2 className='heading'>[ <b>education</b> ]</h2>

      <h3>Concordia University</h3>
      <p className='title'>Full Stack Web Development Diploma</p>
      <p className='date'>Feb – Apr 2021</p>
      <div className='text'>
        <p>
          Completed an intensive 3-month bootcamp mastering modern web application development with the MERN stack.
        </p>
        <ul>
          <li>Programming fundamentals (HTML5, CSS3, JavaScript, Git)</li>
          <li>Server-side APIs with Node.js & Express</li>
          <li>Advanced front-end with React & Redux</li>
          <li>Group and solo full-stack project work</li>
          <li>Data persistence with MongoDB</li>
        </ul>
      </div>
      <LinkButton
        className='black'
        href='https://drive.google.com/file/d/1p4rNMTmKVvvZMKtNy9LmM4H2Dodi2RvJ/view?usp=sharing'
        target='_blank'
        rel='noopener noreferrer'
      >
        View Diploma
      </LinkButton>

      <h3 style={{ marginTop: '60px' }}>Coursera / Google</h3>
      <p className='title'>UX Design Professional Certificate</p>
      <p className='date'>May – Nov 2022</p>
      <div className='text'>
        <p>
          Earned a professional UX design credential through seven Google-developed courses,  
          covering user research, wireframing, prototyping, and high-fidelity design in Figma & XD.
        </p>
        <ul>
          <li>Foundations of UX Design</li>
          <li>Empathize, Define & Ideate</li>
          <li>Wireframes & Low-Fidelity Prototypes</li>
          <li>UX Research & Early Testing</li>
          <li>High-Fidelity Prototypes in Figma</li>
          <li>Responsive Design in Adobe XD</li>
          <li>Design for Social Good</li>
          <li>Three end-to-end UX projects with case studies</li>
        </ul>
      </div>
      <LinkButton
        className='black'
        href='https://coursera.org/share/b081388250531d68def9910a0fc5e4ba'
        target='_blank'
        rel='noopener noreferrer'
      >
        View Certificate
      </LinkButton>
    </div>
  </Wrapper>
)

const Wrapper = styled.section`
  background: #f6f6f6;
  .heading {
    color: ${COLORS.dark};
  }
  button {
    margin-top: 20px;
  }
  .text p {
    margin: 10px 0;
    line-height: 1.5;
  }
  .text ul {
    margin: 10px 0 20px 20px;
    list-style: disc;
    color: #444;
  }
`
